export const API_BASE_URL = "https://api.daress.app/api";
export const FILE_BASE_URL = "https://api.daress.app"; // Base URL for serving uploaded files
export const CLOUDFLARE_AUTH_PROXY = "https://firebase-proxy1.m-sayedahmad92.workers.dev"; // Restored for Auth
export const FIRESTORE_PROXY_URL = `${API_BASE_URL}`; // Deprecated, but kept for compatibility during migration
export const UPLOAD_PROXY_URL = `${API_BASE_URL}/uploads`;
export const VERIFY_TOKEN_URL = `${API_BASE_URL}/auth/sync`;
